import React from 'react';
import './deleteButton.css';

interface DeleteButtonProps {
    onClick: () => void;
    disabled?: boolean;
    isSubmitting?: boolean;
    text?: string;
}

const DeleteButton: React.FC<DeleteButtonProps> = ({
    onClick,
    disabled = false,
    isSubmitting = false,
    text = "Delete",
}) => {

    const isButtonDisabled = disabled || isSubmitting;

    return (
        <button 
            className={`deleteButton-main ${!isButtonDisabled ? 'enabled' : ''}`}
            disabled={isButtonDisabled}
            onClick={onClick}
        >
            {text}
        </button>
    );
};

export default DeleteButton;